import axios from "axios";
import { APIAdapter } from "../../../helpers/api_helper";

const api = new APIAdapter();
const transaction = process.env.REACT_APP_API_TRANSACTION;

  export const getPayements = async () => {
    try {
      const response = await api.get(`/payout-accounts`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const addBankAccount = async (data, selectedBusiness) => {
    try {
      const response = axios.post(`${transaction}/manage/pay-out-account/create/banks?merchant=${data?.merchantId}`, data,
        {
          headers: {
            Authorization: `Bearer ${data?.token}`,
            // "x-api-key": selectedBusiness?.apiKey,
            // "X-API-TOKEN": selectedBusiness?.apiToken,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const updateBankAccount= async (id,data) => {
    try {
      const response = await axios.put(`${transaction}/manage/pay-out-account/banks/${id}?merchant=${data?.merchantId}`, data,
        {
          headers: {
            Authorization: `Bearer ${data?.token}`,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getAccountsBanksByMerchantId = async (id, token) => {
    try {
      const response = await axios.get(`${transaction}/manage/pay-out-account/banks/merchant?merchant=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  export const deActiveBankAccount = async (data) => {
    try {
      const response = await axios.get(`${transaction}/manage/pay-out-account/banks/${data?.id}/toggle-status?merchant=${data?.merchantId}`,
        {
          headers: {
            Authorization: `Bearer ${data?.token}`,
            // "x-api-key": selectedBusiness?.apiKey,
            // "X-API-TOKEN": selectedBusiness?.apiToken,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  
  export const getVersementBanksByMerchantId = async (props) => {
    
    try {
      const response = await axios.get(`${transaction}/manage/pay-out/banks/merchant?merchant=${props?.merchandId}`,
        {
          headers: {
            Authorization: `Bearer ${props?.token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };